import "./style.css";

const TranslaterContentHeader = ({background, text, icon}) => {
	return (
			<div className="translaterContentHeader" style={{backgroundColor: background}}>
				<img src={icon} alt={text} />
				<p>{text}</p>
			</div>
	)
}

export default TranslaterContentHeader;